import React, { Fragment, Component } from 'react'
// import {Link} from 'react-router-dom'
// import axios from 'axios'
import store from '../store'
import Adsimple from '../components/adsimple'
import HonorSimple from '../components/honorsimple'
import LunboFirst from '../components/lunboFirst'

class First extends Component{
  constructor(props){
    super(props);
    this.state = store.getState();
    this.handleStoreChange = this.handleStoreChange.bind(this);
    store.subscribe(this.handleStoreChange);
  }
  render(){
    return(
      <Fragment>
        <LunboFirst lunbo={this.state.lunbo} lunbolink={this.state.lunbolink} />
        {/* <div className='first-topic'>
          <div className='first-topic0'>
            <div>客户案例</div><div><Link to='/custemer'>查看更多</Link></div>
          </div>
        </div> */}
        {this.state.products.map((item,index)=>{
          return <Adsimple picsrc={item} link='/product' key={index} />
        })}
        <HonorSimple honors = {this.state.honors} />
      </Fragment>
    );
  }
  handleStoreChange() {
    this.setState(store.getState());
  }
}
export default First;